export default __webpack_public_path__ + "static/club-card-66f89b6d99c668b39c255be5ab0296f0.png";